import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'

import { Seo } from '@/components/generals/seo'

/* The world measures the live viewport and reads pointer/orientation media
 * queries, so it is mounted on the client only. */
const HollowPines = dynamic(
    () => import('@/components/game/hollow-pines').then(m => m.HollowPines),
    {
        ssr: false,
        loading: () => <div style={{ position: 'fixed', inset: 0, background: '#151013' }} />
    }
)

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Station 7'
                description='Walk the rooms of a snowbound field station, read the casebook, check the trail cameras and ride the ridge before the light goes.'
                ogImage='/images/og-cover.jpg'
            />

            <main>
                <h1 className='sr-only'>
                    Hollow Pines, a walk-around field station on Marrow Ridge
                </h1>

                <HollowPines />
            </main>
        </>
    )
}

export default Home
